import { useEffect, useState } from "react";
import { db } from "../../firebase"
import { doc, getDoc, updateDoc } from "firebase/firestore";

export default function VisitorCounter() {
  const [count, setCount] = useState(0);

  useEffect(() => {
    const updateVisitor = async () => {
      const ref = doc(db, "visits", "counter");
      const snap = await getDoc(ref);

      if (!localStorage.getItem("visited")) {
        const newCount = snap.data().count + 1;
        await updateDoc(ref, { count: newCount });
        localStorage.setItem("visited", "true");
        setCount(newCount);
      } else {
        setCount(snap.data().count);
      }
    };

    updateVisitor();
  }, []);

  return <span>👀 Total Visitors: {count}</span>;
}
